import React, { Suspense } from "react";
import {Redirect, Switch} from "react-router-dom";

import { OrdersPage } from "./Orders";
// import { DeliveryPage } from "./Delivery";
import { LayoutSplashScreen, ContentRoute } from "../../../_metronic/layout";

import { URLs } from "../../../utils/routes";

export function OrdersManagementPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Redirect exact={true} from={URLs.SALES} to={URLs.SALES_ORDERS} />
        <ContentRoute path={URLs.SALES_ORDERS} component={OrdersPage} />
        {/*<ContentRoute path={URLs.SALES_DELIVERY} component={DeliveryPage} />*/}
      </Switch>
    </Suspense>
  );
}
